import * as React from "react";

import { cn } from "@/v2/lib/utils";
import { Button, type ButtonProps } from "./button";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "./tooltip";

type TooltipContentProps = React.ComponentPropsWithoutRef<
	typeof TooltipContent
>;

export interface TooltipButtonProps extends ButtonProps {
	tooltip: React.ReactNode;
	tooltipSide?: TooltipContentProps["side"];
	tooltipAlign?: TooltipContentProps["align"];
	tooltipClassName?: string;
	wrapperClassName?: string;
}

export const TooltipButton = React.forwardRef<
	HTMLButtonElement,
	TooltipButtonProps
>(
	(
		{
			tooltip,
			tooltipSide = "bottom",
			tooltipAlign,
			tooltipClassName,
			wrapperClassName,
			disabled,
			loading,
			title: _title,
			children,
			...props
		},
		ref,
	) => (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<span className={cn("inline-flex", wrapperClassName)}>
						<Button ref={ref} disabled={disabled} loading={loading} {...props}>
							{children}
						</Button>
					</span>
				</TooltipTrigger>
				<TooltipContent
					side={tooltipSide}
					align={tooltipAlign}
					className={tooltipClassName}
				>
					{tooltip}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	),
);

TooltipButton.displayName = "TooltipButton";
